import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23fc3ae2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "safecheckSafe" }
const _hoisted_2 = { class: "submit-container" }
const _hoisted_3 = { style: {"margin":"0.1rem 0","position":"relative"} }
const _hoisted_4 = { class: "button" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("提交")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_billTypePopupComponent = _resolveComponent("billTypePopupComponent")!
  const _component_checkTypePopupComponent = _resolveComponent("checkTypePopupComponent")!
  const _component_inputCheckBox = _resolveComponent("inputCheckBox")!
  const _component_inputprojectshow = _resolveComponent("inputprojectshow")!
  const _component_inputselectshow = _resolveComponent("inputselectshow")!
  const _component_inputSingleSelectshow = _resolveComponent("inputSingleSelectshow")!
  const _component_inputSpeechCheckBox = _resolveComponent("inputSpeechCheckBox")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_limitDatePopupComponent = _resolveComponent("limitDatePopupComponent")!
  const _component_directorPopupComponent = _resolveComponent("directorPopupComponent")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: _ctx.$route.meta.title,
      "left-arrow": "",
      onClickLeft: _ctx.goBack
    }, null, 8, ["title", "onClickLeft"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_form, { onSubmit: _ctx.onSubmit }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_billTypePopupComponent, {
              billIdscolumns: _ctx.billIdscolumns,
              submitform: _ctx.submitform,
              onBillIdsonConfirm: _ctx.billIdsonConfirm
            }, null, 8, ["billIdscolumns", "submitform", "onBillIdsonConfirm"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_checkTypePopupComponent, {
              checkIdscolumns: _ctx.checkIdscolumns,
              submitform: _ctx.submitform,
              onCheckIdsonConfirm: _ctx.checkIdsonConfirm
            }, null, 8, ["checkIdscolumns", "submitform", "onCheckIdsonConfirm"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_inputCheckBox, {
              submitform: _ctx.submitform,
              onInputCheckBox: _ctx.inputCheckBox
            }, null, 8, ["submitform", "onInputCheckBox"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_inputprojectshow, { projectIdscolumns: _ctx.projectIdscolumns }, null, 8, ["projectIdscolumns"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_inputselectshow, {
              "select-columns": _ctx.checkDeptColumns,
              "second-columns": _ctx.checkItemColumns,
              submitform: _ctx.submitform,
              label: "检查项目",
              rank: 1,
              areaform: _ctx.areaForm,
              onDeptChange: _ctx.deptChange
            }, null, 8, ["select-columns", "second-columns", "submitform", "areaform", "onDeptChange"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_inputSingleSelectshow, {
              ref: "itemSel",
              "select-columns": _ctx.checkAreaColumns,
              submitform: _ctx.submitform,
              rank: 0,
              label: "检查部位",
              onAreaChange: _ctx.areaChange
            }, null, 8, ["select-columns", "submitform", "onAreaChange"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_inputSpeechCheckBox, {
              ref: "speechSel",
              columns: _ctx.checkSpeechColumns,
              submitform: _ctx.submitform,
              "check-person-label": "检查用语",
              "domain-list": _ctx.domainList,
              "onUpdate:domain-list": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.domainList) = $event))
            }, null, 8, ["columns", "submitform", "domain-list"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.domainList, (domain, index) => {
              return (_openBlock(), _createBlock(_component_van_field, {
                key: domain.id,
                prop: 'domains.' + index + '.inspectCode',
                rules: [{ required: true, message: '请选择整改前照片' }],
                label: domain.inspectCode + domain.inspectContent,
                required: "",
                style: {"text-wrap":"none"}
              }, {
                input: _withCtx(() => [
                  _createVNode(_component_van_uploader, {
                    modelValue: domain.value,
                    "onUpdate:modelValue": ($event: any) => ((domain.value) = $event),
                    "after-read": _ctx.afterRead,
                    style: {"margin-top":"20px"},
                    multiple: _ctx.$isIOS()
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "after-read", "multiple"])
                ]),
                _: 2
              }, 1032, ["prop", "label"]))
            }), 128))
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_limitDatePopupComponent, {
              onSelectLimit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.submitform.limitDate = $event))
            })
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_directorPopupComponent, {
              onSelectPerson: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submitform.director = $event))
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_van_button, {
              block: "",
              disabled: _ctx.flag,
              type: "primary",
              "native-type": "submit"
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ])
  ]))
}